const H2Style = (theme) => {

    return {
      fontSize: "12pt",
      fontWeight: 600,
      color: theme.palette.primary.main,
    };
  };
  
  export default H2Style;
  